const env = require('../../env')
import {deepClone, isArray, isEmpty, isObject} from '@/utils/common'
import {nanoid} from '@/utils/nanoid'

let wsQueueList = []
let wsResolve = null
export default {
  methods: {
    __mixinsWebSocketFilter(curData,wsData){
      let commonData = deepClone(curData)
      let data = deepClone(wsData)
      let isChange = false
      Object.keys(commonData).forEach((key) => {
        if (isArray(commonData[key]) && !isEmpty(data)) {
          data[key].forEach((item) => {
            const { plan_flag } = item.plan_info || {}
            let findIndex = commonData[key].findIndex((v) => {
              if (key == 'filter_company'){
                return v.id == item.id
              }else{
                return v.plan_info.plan_flag == plan_flag
              }
            })
            if (findIndex == -1) {
              isChange = true
              commonData[key].push(item)
            } else {
              // console.log('same', plan_flag)
            }
          })
        }
      })
      return {
        res: commonData,
        isChange
      }
    },
    __mixinsWebSocketInit(options){
      this.__webSocketOptions = options
      import('../utils/im.js').then(e => {
        this.__mixinsWebSocketInitConnect()
      })
        .catch(err => {
          console.log(err)
        })
    },
    __mixinsWebSocketInitConnect(){
      const { eventName } = this.__webSocketOptions || {}
      const wsUrl = env.WEBSOCKET_URL
      this.__webSocket = new IM({
        url: wsUrl,
        protocols: this.accessToken
      })
      this.__webSocket.OnOpen(() => {
        console.log('wsOnOpen')
        this.__isWebSocketConnect = true
        while (this.__tasks && this.__tasks.length) {
          let { eventName, paramsString, id } = this.__tasks.shift()
          this.__webSocket.Eimt(id,eventName, paramsString)
        }
      })

      this.__webSocket.OnError(() => {
        wsQueueList.forEach((item) => {
          let { rej } = item
          rej && rej()
        })
        this.__isWebSocketConnect = false
      })

      eventName && this.__webSocket.On(eventName,(data,wsId) => {
        wsQueueList.forEach((item)=>{
          let { res, rej, id } = item
          if (wsId == id) {
            if (this.__webSocketLoading) {
              // webSocket 先返回数据
              console.log('webSocket 先返回数据', wsId)
              wsResolve = {
                data,
                wsId
              }
            }else{
              // quoteList 先返回数据
              console.log('quoteList 先返回数据', wsId)
              res && res(data)
            }
          }
        })
      })
    },
    __mixinsWebSocketReconnect(){
      if (this.__webSocket){
        this.__webSocket.Close()
        this.__isWebSocketConnect = false

        wsQueueList.forEach((item) => {
          let { eventName, paramsString, id } = item
          this.__tasks = [
            {
              eventName,
              paramsString,
              id
            }
          ]
        })


        this.__mixinsWebSocketInitConnect()


      }
    },
    __mixinsWebSocketResolve(){
      this.__webSocketLoading = false
      if (wsResolve){
        const { data, wsId } = wsResolve || {}
        wsQueueList.forEach((item) => {
          let { res, rej, id } = item
          if (wsId == id) {
            console.log('__mixinsWebSocketResolve', wsId)
            res && res(data)
          }
        })
        wsResolve = null
      }
    },
    __mixinsWebSocketEmit(eventName,params){
      this.__webSocketLoading = true
      let objParams = {
        ...params
      }
      const paramsString = isObject(objParams) ? JSON.stringify(objParams) : objParams
      const curId = nanoid()
      return new Promise((res,rej)=>{
        wsQueueList = [
          {
            res,
            rej,
            id: curId,
            eventName,
            paramsString
          }
        ]
        if (this.__isWebSocketConnect) {
          this.__webSocket.Eimt(curId, eventName, paramsString)
        } else {
          this.__tasks = [
            {
              eventName,
              paramsString,
              id: curId
            }
          ]
        }
      })
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    this.__webSocket && this.__webSocket.Close()
    this.__webSocket = null
    wsQueueList = []
    wsResolve = null
    this.__webSocketLoading = false
    this.__isWebSocketConnect = false
    this.__tasks = null
    this.__webSocketOptions = null
  }
}
